import React, {useState} from "react";

function useWithPercentageValue(initialValue, initialPercentage) {
    const [value, setValue] = useState(initialValue || '');
    const [percentage, setPercentage] = useState(initialPercentage || '');

    return {
        value, setValue,
        percentage, setPercentage
    }
}

export default useWithPercentageValue;